// extracted by mini-css-extract-plugin
module.exports = {"mynvoiceLogo":"MynvoiceLogoComponent_mynvoiceLogo__1Hn-t"};